import { DataSource } from '~/Api/Product/SearchableDataSource';
import GroupedDataSource from '~/Api/DataSource/GroupedDataSource';
import { LoadPersistentStateAction, PersistenStateActionTypes } from '~/Store/actions';

import ActionTypes from './ActionTypes';

import { type Action as AccessTokenAction, ActionType as AccessTokenActionType } from '~/AccessToken';
import { type Action as ImpersonateAction, ActionType as ImpersonateActionType } from '~/UserImpersonate';
import type { DatasetPresence, PricesPresence } from '~/Api/Product';

export interface State {
	request: Promise<any> | null;
	groupedRequest: Promise<any> | null;
	isFetching: boolean;
	dataSources: DataSource[] | null;
	groupedDataSources: GroupedDataSource[] | null;
	selectedTypes: Set<string> | null;
	selectedGrouppingType: string | null;
	selectedGroupName: string | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence | null;
}

export type RecivedGroupedDataSroucesAction = {
	type: ActionTypes.receiveGrouped;
	request: Promise<any>;
	groupedDataSources: GroupedDataSource[] | null;
};

export type RequestGroupDataSourcesAction = { type: ActionTypes.requestGrouped; request: Promise<any> };
export type UpdateSelectedDataSourcesAction = {
	type: ActionTypes.updatedSelectedTypes;
	selectedTypes: Set<string> | null;
	selectedGrouppingType: string | null;
	groupName: string | null;
	pricesPresence: PricesPresence | null;
	datasetPresence: DatasetPresence | null;
};

type Action =
	| LoadPersistentStateAction
	| { type: ActionTypes.request; request: Promise<any> }
	| RequestGroupDataSourcesAction
	| {
			type: ActionTypes.receive;
			request: Promise<any>;
			dataSources: DataSource[];
	  }
	| RecivedGroupedDataSroucesAction
	| UpdateSelectedDataSourcesAction;

export default function reducer(
	state: State = createState(),
	action: Action | ImpersonateAction | AccessTokenAction
): State {
	switch (action.type) {
		case ActionTypes.request:
			return { ...state, request: action.request, isFetching: true };

		case ActionTypes.requestGrouped:
			return { ...state, groupedRequest: action.request, isFetching: true };

		case ActionTypes.receive:
			return state.request === action.request
				? {
						...state,
						request: action.dataSources ? action.request : null,
						isFetching: false,
						dataSources: action.dataSources,
				  }
				: {
						...createState(),
						groupedRequest: state.groupedRequest,
						groupedDataSources: state.groupedDataSources,
				  };

		case ActionTypes.receiveGrouped:
			return state.groupedRequest === action.request
				? {
						...state,
						groupedRequest: action.groupedDataSources ? action.request : null,
						isFetching: false,
						groupedDataSources: action.groupedDataSources,
				  }
				: {
						...createState(),
						request: state.request,
						dataSources: state.dataSources,
				  };

		case ActionTypes.updatedSelectedTypes:
			return {
				...state,
				selectedTypes: action.selectedTypes,
				selectedGrouppingType: action.selectedGrouppingType,
				selectedGroupName: action.groupName,
				datasetPresence: action.datasetPresence,
				pricesPresence: action.pricesPresence,
			};

		case PersistenStateActionTypes.load:
			if (action.revivedPersistedState?.productSearchableDataSource) {
				return {
					...state,
					...action.revivedPersistedState.productSearchableDataSource,
				};
			}

			return state;

		case ImpersonateActionType.receive:
		case ImpersonateActionType.receiveSwitchBack:
		case AccessTokenActionType.logout:
			// NOTE: due to persistence
			return createState();

		default:
			return state;
	}
}

function createState(): State {
	return {
		request: null,
		groupedRequest: null,
		isFetching: false,
		dataSources: null,
		groupedDataSources: null,
		selectedTypes: null,
		selectedGrouppingType: null,
		selectedGroupName: null,
		pricesPresence: null,
		datasetPresence: null,
	};
}
